import { ID } from './id';
import { Roles } from './roles';
import { Timestamp } from './timestamp';

export enum ExternalConnectionsTypes {
  Calendar = 'calendar',
}

export enum ExternalConnectionsProviders {
  Google = 'google',
  Outlook = 'outlook',
}

export type ExternalConnectionGoogleProviderInfo = {
  email: string;
  id: ID;
};

export type ExternalConnectionGoogleSettings = {
  calendarBlacklist?: ID[] | null;
};

export type ExternalConnection = {
  createdAt: Timestamp;
  lastUsedAt: Timestamp;
  id: ID;
  provider: ExternalConnectionsProviders;
  providerInfo: ExternalConnectionGoogleProviderInfo;
  roles: Roles;
  type: ExternalConnectionsTypes;
  updatedAt: Timestamp;
  settings?: ExternalConnectionGoogleSettings | null;
};
